import { css, styled } from "styled-components";

const PTag = styled.p`
  ${(props) => props.type === 'resource' && css`
    font-size: 30px;
  `}
`;

export const Paragraph = (props) => {
  return (
    <PTag type={props.type}>{props.children}</PTag>
  );
};